
import React, { useState, useImperativeHandle, forwardRef, useEffect } from 'react'
import Api from '../../../../../_helpers/Api'
import { trans } from '../../../../../_providers/Translation'
import docIcon from '../../../../../assets/img/icons/document.png'
import closeIcon from '../../../../../assets/img/icons/close.png'
import loader from '../../../../../assets/img/loader.svg'
import { useAuthDataContext } from '../../../../../_providers/Auth'
import { Checkbox, FormControlLabel, Radio } from '@mui/material'
import popupDefaultHeadImage from "@/assets/img/modals/icons/head.svg"
import leftArrowIcon from "@/assets/img/reservations/icons/left-arrow.svg"

// Helper to format date as dd/mm/yyyy
function formatDateDMY(dateStr) {
    if (!dateStr) return ''
    const [date] = dateStr.split(' ')
    const [y, m, d] = date.split('-')
    if (!y || !m || !d) return dateStr
    return `${d}/${m}/${y}`
}

function AddInvoice(props, ref) {

    const auth = useAuthDataContext()

    const initialValidations = {}

    const initialParams = {
        type_id: 1,
        diagnostic_charge: 0,
        labour_charge: 0,
        transport_charge: 0,
        parts_charge: 0,
        parts: {},
        stockparts: {},
        parts_qty: 0,
        parts_price: 0,
        parts_vat_price: 0,
        parts_gross_price: 0
    }

    const [state, setState] = useState({
        validations: initialValidations,
        overlay: false,
        modal: false,
        loading: false,
        data: null,
        parts: [],
        stockparts: [],
        params: initialParams,
        relatedReservations: [],
        selectedReservations: {},
        relatedCharges: {} // Store selected charges per reservation: { reservationId: { diagnostic: true, labour: false, ... } }
    })

    useImperativeHandle(ref, () => ({
        open: (id) => {
            handleOpen(id)
        },
        close: () => {
            handleClose()
        }
    }))

    useEffect(() => {

        if (props.data.id) {
            setState(prev => ({
                ...prev,
                data: props.data,
                parts: props.data.parts,
                stockparts: props.data.stockparts,
            }))
        }

    }, [props.data])

    const calcPartsTotals = (allParts, allStockParts, selectedParts, selectedStockParts) => {
        let qty = 0, price = 0, vatprice = 0, grossprice = 0

            ; (allParts || []).forEach(p => {
                if (selectedParts[p.id] || selectedParts[String(p.id)]) {
                    qty += parseFloat(p.quantity) || 0
                    price += parseFloat(p.converted_price) || parseFloat(p.converted_price_formatted) || 0
                    vatprice += parseFloat(p.converted_vat_price) || parseFloat(p.converted_vat_price_formatted) || 0
                    grossprice += parseFloat(p.converted_gross_price) || parseFloat(p.converted_gross_price_formatted) || 0
                }
            })

            ; (allStockParts || []).forEach(p => {
                if (selectedStockParts[p.id] || selectedStockParts[String(p.id)]) {
                    qty += parseFloat(p.quantity) || 0
                    price += parseFloat(p.converted_price) || parseFloat(p.converted_price_formatted) || 0
                    vatprice += parseFloat(p.converted_vat_price) || parseFloat(p.converted_vat_price_formatted) || 0
                    grossprice += parseFloat(p.converted_gross_price) || parseFloat(p.converted_gross_price_formatted) || 0
                }
            })

        return {
            parts_qty: qty,
            parts_price: price.toFixed(2),
            parts_vat_price: vatprice.toFixed(2),
            parts_gross_price: grossprice.toFixed(2)
        }
    }

    const handleOpen = (id) => {
        setState(prev => ({
            ...prev,
            overlay: true,
        }))

        // Fetch related reservations with full details including charges
        Api.get(`reservations/related?id=${id}&include_charges=true`)
            .then(res => {
                const relatedReservations = res.data.data || res.data || []
                // Set all related reservations to unchecked by default
                const selectedReservations = {}
                const relatedCharges = {}
                relatedReservations.forEach(reservation => {
                    selectedReservations[reservation.id] = false
                    relatedCharges[reservation.id] = {
                        diagnostic: false,
                        labour: false,
                        transport: false,
                        parts: false
                    }
                })
                setState(prev => ({
                    ...prev,
                    relatedReservations: relatedReservations,
                    selectedReservations: selectedReservations,
                    relatedCharges: relatedCharges
                }))
            })
            .catch(err => {
                console.error('Failed to load related reservations', err)
            })

        setTimeout(() => {
            setState(prev => ({
                ...prev,
                modal: true,
            }))
        }, 50)
    }

    const handleClose = e => {
        if (e) e.preventDefault()

        setState(prev => ({
            ...prev,
            modal: false,
            params: initialParams,
            relatedReservations: [],
            selectedReservations: {},
            relatedCharges: {}
        }))

        setTimeout(() => {
            setState(prev => ({
                ...prev,
                overlay: false,
            }))
        }, 50)
    }

    const handleSave = e => {
        e.preventDefault()

        setState(prev => ({
            ...prev,
            validations: initialValidations,
            loading: true
        }))

        let url = 'invoices/create/' + types[state.params.type_id].url

        let data = new FormData(e.target)

        data.append('reservation_id', state.data.id)

        // Add selected related reservations with their selected charges as form data with indexes
        const selectedReservationsData = Object.keys(state.selectedReservations)
            .filter(id => state.selectedReservations[id])
            .map(id => ({
                id: parseInt(id),
                charges: state.relatedCharges[id] || {}
            }))

        selectedReservationsData.forEach((reservation, index) => {
            data.append(`related_reservations[${index}][id]`, reservation.id)
            data.append(`related_reservations[${index}][diagnostic]`, reservation.charges.diagnostic ? '1' : '0')
            data.append(`related_reservations[${index}][labour]`, reservation.charges.labour ? '1' : '0')
            data.append(`related_reservations[${index}][transport]`, reservation.charges.transport ? '1' : '0')
            data.append(`related_reservations[${index}][parts]`, reservation.charges.parts ? '1' : '0')
        })

        Api.post(url, data)
            .then(res => {
                props.refreshData()
                handleClose()
            })
            .catch(error => {
                let _err = error.response

                if (_err && _err.status && _err.status == 422) {
                    for (let [input, err] of Object.entries(_err.data.errors)) {
                        setState(prev => ({
                            ...prev,
                            validations: {
                                ...prev.validations,
                                [input]: true
                            }
                        }))
                    }
                }
            }).finally(() => {
                setState(prev => ({
                    ...prev,
                    loading: false
                }))
            })
    }

    const handleInputChange = e => {
        let name = e.target.name
        let val = e.target.value

        setState(prev => ({
            ...prev,
            params: {
                ...prev.params,
                [name]: val
            }
        }))
    }

    function handlePartsChargeToggle() {
        setState(prev => ({
            ...prev,
            params: {
                ...prev.params,
                parts_charge: !prev.params.parts_charge
            }
        }))
    }

    const handleCheckboxChange = e => {
        let name = e.target.name

        setState(prev => ({
            ...prev,
            params: {
                ...prev.params,
                [name]: !prev.params[name]
            }
        }))
    }

    const handlePartsCheckboxChange = e => {
        const id = e.target.value
        setState(prev => {
            const newSelectedParts = { ...prev.params.parts, [id]: !prev.params.parts[id] }
            const totals = calcPartsTotals(prev.parts, prev.stockparts, newSelectedParts, prev.params.stockparts)
            return { ...prev, params: { ...prev.params, parts: newSelectedParts, ...totals } }
        })
    }

    const handleStockPartsCheckboxChange = e => {
        const id = e.target.value
        setState(prev => {
            const newSelectedStockParts = { ...prev.params.stockparts, [id]: !prev.params.stockparts[id] }
            const totals = calcPartsTotals(prev.parts, prev.stockparts, prev.params.parts, newSelectedStockParts)
            return { ...prev, params: { ...prev.params, stockparts: newSelectedStockParts, ...totals } }
        })
    }

    const handleRelatedReservationToggle = (reservationId) => {
        setState(prev => ({
            ...prev,
            selectedReservations: {
                ...prev.selectedReservations,
                [reservationId]: !prev.selectedReservations[reservationId]
            }
        }))
    }

    const handleSelectAllRelated = () => {
        const allSelected = state.relatedReservations.every(
            res => state.selectedReservations[res.id]
        )

        const selectedReservations = {}
        if (!allSelected) {
            state.relatedReservations.forEach(res => {
                selectedReservations[res.id] = true
            })
        }

        setState(prev => ({
            ...prev,
            selectedReservations
        }))
    }

    const handleRelatedChargeToggle = (reservationId, chargeType) => {
        setState(prev => ({
            ...prev,
            relatedCharges: {
                ...prev.relatedCharges,
                [reservationId]: {
                    ...prev.relatedCharges[reservationId],
                    [chargeType]: !prev.relatedCharges[reservationId]?.[chargeType]
                }
            }
        }))
    }

    const types = {
        1: {
            name: trans('random.proforma'),
            url: 'proforma'
        },
        2: {
            name: trans('random.invoice'),
            url: 'invoice'
        }
    }

    // Compute parts totals from current selections — runs on every render, always in sync
    let _partsQty = 0, _partsPrice = 0, _partsVat = 0, _partsGross = 0
        ; (state.parts || []).forEach(p => {
            if (state.params.parts[p.id] || state.params.parts[String(p.id)]) {
                _partsQty += parseFloat(p.quantity) || 0
                _partsPrice += parseFloat(p.converted_price) || parseFloat(p.converted_price_formatted) || 0
                _partsVat += parseFloat(p.converted_vat_price) || parseFloat(p.converted_vat_price_formatted) || 0
                _partsGross += parseFloat(p.converted_gross_price) || parseFloat(p.converted_gross_price_formatted) || 0
            }
        })
        ; (state.stockparts || []).forEach(p => {
            if (state.params.stockparts[p.id] || state.params.stockparts[String(p.id)]) {
                _partsQty += parseFloat(p.quantity) || 0
                _partsPrice += parseFloat(p.converted_price) || parseFloat(p.converted_price_formatted) || 0
                _partsVat += parseFloat(p.converted_vat_price) || parseFloat(p.converted_vat_price_formatted) || 0
                _partsGross += parseFloat(p.converted_gross_price) || parseFloat(p.converted_gross_price_formatted) || 0
            }
        })

    return (
        <div className={`${state.overlay ? 'visible' : ''} overlay`}>

            <form onSubmit={handleSave} className={`${state.modal ? 'show' : ''} popup-primary large`}>
                <div className='head-new'>
                    <img src={popupDefaultHeadImage} alt="icon" />
                    <div className='texts'>
                        <h2>
                            {trans('headings.createDocument')}
                        </h2>
                        <p>{trans('subheadings.createDocument')}</p>
                    </div>
                    <span className='close' onClick={handleClose}>

                    </span>
                </div>


                {!state.data
                    ?
                    <img src={loader} alt="loading" />
                    :
                    <>
                        <div
                            className="row"
                        >
                            {Object.entries(types).map(t =>
                                <FormControlLabel
                                    control={
                                        <Radio
                                            name="type_id"
                                            value={t[0]}
                                            checked={Number(state.params.type_id) === Number(t[0])}
                                            onChange={handleInputChange}
                                        />
                                    }
                                    label={t[1].name}
                                    key={'type-' + t[0]}
                                />
                            )}
                        </div>
                        <b
                            style={{
                                fontFamily: "Inter Bold",
                                fonSize: "18px",
                                marginBottom: "10px",
                                display: "block"
                            }}
                        >
                            {trans('random.toInclude')}
                        </b>
                        <div className="table-scroller" style={{ padding: '0 10px 0 0' }}>

                            <table>
                                <thead>
                                    <tr>
                                        <th className="center" style={{ width: '40px' }}>

                                        </th>
                                        <th style={{ width: '30%' }}>
                                            {trans('tables.description')}
                                        </th>
                                        <th style={{ width: '40px' }}>
                                            {trans('tables.quantity')}
                                        </th>
                                        <th style={{ width: '20%' }}>
                                            {trans('tables.netPrice')}
                                        </th>
                                        <th style={{ width: '20%' }}>
                                            {trans('tables.tax')}
                                        </th>
                                        <th style={{ width: '20%' }}>
                                            {trans('tables.gross')}
                                        </th>
                                        <th style={{ width: '10%' }}>
                                            {trans('tables.document')}
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {/* диагностика */}
                                    <tr>
                                        <td className="center" style={{ width: '40px' }}>
                                            <Checkbox
                                                name="diagnostic_charge"
                                                value="1"
                                                checked={state.params.diagnostic_charge}
                                                disabled={state.data.diagnosticinvoice || state.data.diagnostic_price === 0 ? true : false}
                                                onChange={handleCheckboxChange}
                                                size='small'
                                            />
                                        </td>
                                        <td style={{ width: '30%' }}>
                                            {trans('tables.diagnosticPrice')}
                                        </td>
                                        <td style={{ width: '40px' }}>
                                            1
                                        </td>
                                        <td style={{ width: '20%' }}>
                                            {state.data.diagnostic_net_price_formatted}
                                            {state.data?.currency?.name}
                                        </td>
                                        <td style={{ width: '20%' }}>
                                            {state.data.diagnostic_vat_price_formatted}
                                            {state.data?.currency?.name}
                                        </td>
                                        <td style={{ width: '20%' }}>
                                            {state.data.diagnostic_gross_price_formatted}
                                            {state.data?.currency?.name}
                                        </td>
                                        <td style={{ width: '10%' }}>
                                            {state.data.diagnosticinvoice ? (
                                                <div>
                                                    {state.data.diagnosticinvoice.signed_url ? (
                                                        <a href={state.data.diagnosticinvoice.signed_url} target="_blank" rel="noopener noreferrer">
                                                            {state.data.diagnosticinvoice.number || state.data.diagnosticinvoice.no}
                                                        </a>
                                                    ) : (
                                                        state.data.diagnosticinvoice.number || state.data.diagnosticinvoice.no || '-'
                                                    )}
                                                    <br />
                                                    <span>
                                                        {state.data.diagnosticinvoice.date_dmy || (state.data.diagnosticinvoice.date ? formatDateDMY(state.data.diagnosticinvoice.date) : '')}
                                                    </span>
                                                </div>
                                            ) : '-'}
                                        </td>
                                    </tr>
                                    {/* труд */}
                                    <tr>
                                        <td className="center" style={{ width: '40px' }}>
                                            <Checkbox
                                                name="labour_charge"
                                                value="1"
                                                checked={state.params.labour_charge}
                                                disabled={state.data.labourinvoice || state.data.labour_price === 0 ? true : false}
                                                // disabled={state.data.labour_payable_price > 0 ? false : true}
                                                // disabled={state.data.labour_price > 0 ? false : true}
                                                onChange={handleCheckboxChange}
                                                size='small'
                                            />
                                        </td>
                                        <td style={{ width: '30%' }}>
                                            {trans('tables.labourPrice')}
                                        </td>
                                        <td style={{ width: '40px' }}>
                                            1
                                        </td>
                                        <td style={{ width: '20%' }}>
                                            {state.data.labour_net_price_formatted}
                                            {state.data?.currency?.name}
                                        </td>
                                        <td style={{ width: '20%' }}>
                                            {state.data.labour_vat_price_formatted}
                                            {state.data?.currency?.name}
                                        </td>
                                        <td style={{ width: '20%' }}>
                                            {state.data.labour_gross_price_formatted}
                                            {state.data?.currency?.name}
                                        </td>
                                        <td style={{ width: '10%' }}>
                                            {state.data.labourinvoice ? (
                                                <div>
                                                    {state.data.labourinvoice.signed_url ? (
                                                        <a href={state.data.labourinvoice.signed_url} target="_blank" rel="noopener noreferrer">
                                                            {state.data.labourinvoice.number || state.data.labourinvoice.no}
                                                        </a>
                                                    ) : (
                                                        state.data.labourinvoice.number || state.data.labourinvoice.no || '-'
                                                    )}
                                                    <br />
                                                    <span>
                                                        {state.data.labourinvoice.date_dmy || (state.data.labourinvoice.date ? formatDateDMY(state.data.labourinvoice.date) : '')}
                                                    </span>
                                                </div>
                                            ) : '-'}
                                        </td>
                                    </tr>
                                    {/* транспорт */}
                                    <tr>
                                        <td className="center" style={{ width: '40px' }}>
                                            <Checkbox
                                                name="transport_charge"
                                                value="1"
                                                checked={state.params.transport_charge}
                                                disabled={state.data.transportinvoice || state.data.transport_price === 0 ? true : false}
                                                // disabled={state.data.transport_payable_price > 0 ? false : true}
                                                // disabled={state.data.transport_price > 0 ? false : true}
                                                onChange={handleCheckboxChange}
                                                size='small'
                                            />
                                        </td>
                                        <td style={{ width: '30%' }}>
                                            {trans('tables.transportPrice')}
                                        </td>
                                        <td style={{ width: '40px' }}>
                                            1
                                        </td>
                                        <td style={{ width: '20%' }}>
                                            {state.data.transport_net_price_formatted}
                                            {state.data?.currency?.name}
                                        </td>
                                        <td style={{ width: '20%' }}>
                                            {state.data.transport_vat_price_formatted}
                                            {state.data?.currency?.name}
                                        </td>
                                        <td style={{ width: '20%' }}>
                                            {state.data.transport_gross_price_formatted}
                                            {state.data?.currency?.name}
                                        </td>
                                        <td style={{ width: '10%' }}>
                                            {state.data.transportinvoice ? (
                                                <div>
                                                    {state.data.transportinvoice.signed_url ? (
                                                        <a href={state.data.transportinvoice.signed_url} target="_blank" rel="noopener noreferrer">
                                                            {state.data.transportinvoice.number || state.data.transportinvoice.no}
                                                        </a>
                                                    ) : (
                                                        state.data.transportinvoice.number || state.data.transportinvoice.no || '-'
                                                    )}
                                                    <br />
                                                    <span>
                                                        {state.data.transportinvoice.date_dmy || (state.data.transportinvoice.date ? formatDateDMY(state.data.transportinvoice.date) : '')}
                                                    </span>
                                                </div>
                                            ) : '-'}
                                        </td>
                                    </tr>
                                    {/* части */}
                                    {state.data.parts_count > 0 || state.data.stockparts_count > 0
                                        ?
                                        <tr
                                            style={{ backgroundColor: '#f9f9f9', cursor: 'pointer' }}
                                            onClick={handlePartsChargeToggle}
                                        >
                                            <td className="center" style={{ width: '40px' }}>
                                                {/* <Checkbox
                                                    name="parts_charge"
                                                    value="1"
                                                    checked={state.params.parts_charge}
                                                    onChange={handleCheckboxChange}
                                                    size='small'
                                                /> */}

                                                <img
                                                    src={leftArrowIcon}
                                                    alt="related"
                                                    style={{
                                                        width: '10px',
                                                        transition: 'transform 0.3s',
                                                        transform: `rotate(${state.params.parts_charge || false ? -90 : 0}deg)`,
                                                    }}
                                                />
                                            </td>
                                            <td style={{ width: '30%' }}>
                                                {trans('tables.partsPrice')}
                                            </td>
                                            <td style={{ width: '40px' }}>
                                                {_partsQty}
                                            </td>
                                            <td style={{ width: '20%' }}>
                                                {_partsPrice ?
                                                    <>
                                                        {_partsPrice.toFixed(2)}
                                                        {state.data?.currency?.name}
                                                    </>
                                                    :
                                                    '-'
                                                }
                                            </td>
                                            <td style={{ width: '20%' }}>
                                                {_partsPrice ?
                                                    <>
                                                        {_partsVat.toFixed(2)}
                                                        {state.data?.currency?.name}
                                                    </>
                                                    :
                                                    '-'
                                                }
                                            </td>
                                            <td style={{ width: '20%' }}>
                                                {_partsPrice ?
                                                    <>
                                                        {_partsGross.toFixed(2)}
                                                        {state.data?.currency?.name}
                                                    </>
                                                    :
                                                    '-'
                                                }
                                            </td>
                                            <td style={{ width: '10%' }}>

                                            </td>
                                        </tr>
                                        :
                                        ''
                                    }

                                    {state.params.parts_charge ?
                                        <>
                                            {/* <tr>
                                                <td colSpan="7" style={{ padding: '0' }}>
                                                    <h3 className="heading">
                                                        {trans('tables.parts')}
                                                    </h3>
                                                </td>
                                            </tr> */}

                                            {state.parts.map(p =>
                                                <tr key={'part-' + p.id}>
                                                    <td className="center" style={{ width: '40px' }}>
                                                        <Checkbox
                                                            name="parts[]"
                                                            value={p.id}
                                                            checked={!!state.params.parts[p.id]}
                                                            // disabled={(p.invoice && !p.invoice.credited) || !state.data.can_generate_parts_invoice ? true : false}
                                                            disabled={(p.invoice && !p.invoice.credited) ? true : false}
                                                            onChange={handlePartsCheckboxChange}
                                                            size='small'
                                                        />
                                                    </td>
                                                    <td style={{ width: '30%' }}>
                                                        {p.name}
                                                    </td>
                                                    <td style={{ width: '40px' }}>
                                                        {p.quantity}
                                                    </td>
                                                    <td style={{ width: '20%' }}>
                                                        {p.converted_price_formatted}
                                                        {state.data?.currency?.name}
                                                    </td>
                                                    <td style={{ width: '20%' }}>
                                                        {p.converted_vat_price_formatted}
                                                        {state.data?.currency?.name}
                                                    </td>
                                                    <td style={{ width: '20%' }}>
                                                        {p.converted_gross_price_formatted}
                                                        {state.data?.currency?.name}
                                                    </td>
                                                    <td style={{ width: '10%' }}>
                                                        {p.invoice
                                                            ?
                                                            <div>
                                                                <a href={`${p.invoice.signed_url}`} target="_blank">
                                                                    {p.invoice.number}
                                                                </a>
                                                                <br />
                                                                <span>
                                                                    {p.invoice.date_dmy}
                                                                </span>
                                                            </div>
                                                            :
                                                            '-'
                                                        }
                                                    </td>
                                                </tr>
                                            )}
                                            {state.stockparts.map(p =>
                                                <tr key={'stockpart-' + p.id}>
                                                    <td className="center" style={{ width: '40px' }}>
                                                        <Checkbox
                                                            name="stockparts[]"
                                                            value={p.id}
                                                            checked={!!state.params.stockparts[p.id]}
                                                            disabled={p.invoice && !p.invoice.credited ? true : false}
                                                            onChange={handleStockPartsCheckboxChange}
                                                            size='small'
                                                        />
                                                    </td>
                                                    <td style={{ width: '30%' }}>
                                                        {p.storage.part.name}
                                                    </td>
                                                    <td style={{ width: '40px' }}>
                                                        {p.quantity}
                                                    </td>
                                                    <td style={{ width: '20%' }}>
                                                        {p.converted_price_formatted}
                                                        {state.data?.currency?.name}
                                                    </td>
                                                    <td style={{ width: '20%' }}>
                                                        {p.converted_vat_price_formatted}
                                                        {state.data?.currency?.name}
                                                    </td>
                                                    <td style={{ width: '20%' }}>
                                                        {p.converted_gross_price_formatted}
                                                        {state.data?.currency?.name}
                                                    </td>
                                                    <td style={{ width: '10%' }}>
                                                        {p.invoice
                                                            ?
                                                            <div>
                                                                <a href={`${p.invoice.signed_url}`} target="_blank">
                                                                    {p.invoice.number}
                                                                </a>
                                                                <br />
                                                                <span>
                                                                    {p.invoice.date_dmy}
                                                                </span>
                                                            </div>
                                                            :
                                                            '-'
                                                        }
                                                    </td>
                                                </tr>
                                            )}

                                        </>
                                        :
                                        ''
                                    }

                                    {/* Related Reservations Section */}
                                    {state.relatedReservations && state.relatedReservations.length > 0 && (
                                        <>
                                            <tr>
                                                <td colSpan="7" style={{ padding: '20px 0 10px 0', borderTop: '2px solid #ddd' }}>
                                                    <h3 className="heading" style={{ marginTop: '10px' }}>
                                                        {trans('headings.relatedReservations')}
                                                    </h3>
                                                </td>
                                            </tr>
                                            {state.relatedReservations.map(reservation => (
                                                <React.Fragment key={`related-charge-${reservation.id}`}>
                                                    <tr
                                                        style={{ backgroundColor: '#f9f9f9', cursor: 'pointer' }}
                                                        onClick={() => handleRelatedReservationToggle(reservation.id)}
                                                    >
                                                        <td className="center" style={{ width: '40px' }}>
                                                            {/* <Checkbox
                                                                checked={state.selectedReservations[reservation.id] || false}
                                                                onChange={() => handleRelatedReservationToggle(reservation.id)}
                                                                size='small'
                                                            /> */}
                                                            <img
                                                                src={leftArrowIcon}
                                                                alt="related"
                                                                style={{
                                                                    width: '10px',
                                                                    transition: 'transform 0.3s',
                                                                    transform: `rotate(${state.selectedReservations[reservation.id] || false ? -90 : 0}deg)`,
                                                                }}
                                                            />
                                                        </td>
                                                        <td colSpan="6">
                                                            <span
                                                                // className="btn"
                                                                style={{
                                                                    // background: reservation.color || '#999',
                                                                    // color: reservation.text_color || '#fff',
                                                                    padding: '2px 6px',
                                                                    borderRadius: '3px',
                                                                    fontSize: '11px',
                                                                    marginRight: '10px'
                                                                }}
                                                            >
                                                                {reservation.reference_code}
                                                            </span>
                                                            <span style={{ fontWeight: 'bold' }}>
                                                                {reservation.created_at || '-'}
                                                            </span>
                                                            {reservation.parent_id && (reservation.reclamation || reservation.is_reclamation) && (
                                                                <span
                                                                    className="btn"
                                                                    style={{
                                                                        background: '#e74c3c',
                                                                        color: '#fff',
                                                                        padding: '2px 6px',
                                                                        borderRadius: '3px',
                                                                        fontSize: '10px',
                                                                        marginLeft: '10px'
                                                                    }}
                                                                >
                                                                    {trans('buttons.reclamation')}
                                                                </span>
                                                            )}
                                                            {reservation.parent_id && !(reservation.reclamation || reservation.is_reclamation) && (
                                                                <span
                                                                    className="btn"
                                                                    style={{
                                                                        background: '#3498db',
                                                                        color: '#fff',
                                                                        padding: '2px 6px',
                                                                        borderRadius: '3px',
                                                                        fontSize: '10px',
                                                                        marginLeft: '10px'
                                                                    }}
                                                                >
                                                                    {trans('random.continuation')}
                                                                </span>
                                                            )}
                                                        </td>
                                                    </tr>

                                                    {state.selectedReservations[reservation.id] && (
                                                        <>
                                                            {/* Diagnostic */}
                                                            <tr>
                                                                <td className="center" style={{ width: '40px', paddingLeft: '20px' }}>
                                                                    <Checkbox
                                                                        checked={state.relatedCharges[reservation.id]?.diagnostic || false}
                                                                        disabled={reservation.diagnostic_invoice_id || reservation.diagnostic_net_price === 0}
                                                                        onChange={() => handleRelatedChargeToggle(reservation.id, 'diagnostic')}
                                                                        size='small'
                                                                    />
                                                                </td>
                                                                <td style={{ width: '30%', paddingLeft: '20px' }}>
                                                                    {trans('tables.diagnosticPrice')}
                                                                </td>
                                                                <td style={{ width: '40px' }}>1</td>
                                                                <td style={{ width: '20%' }}>
                                                                    {reservation.diagnostic_net_price_formatted || '0.00'}
                                                                    {state.data?.currency?.name}
                                                                </td>
                                                                <td style={{ width: '20%' }}>
                                                                    {reservation.diagnostic_vat_price_formatted || '0.00'}
                                                                    {state.data?.currency?.name}
                                                                </td>
                                                                <td style={{ width: '20%' }}>
                                                                    {reservation.diagnostic_gross_price_formatted || '0.00'}
                                                                    {state.data?.currency?.name}
                                                                </td>
                                                                <td style={{ width: '10%' }}>
                                                                    {reservation.diagnostic_invoice ? (
                                                                        <div>
                                                                            {reservation.diagnostic_invoice.signed_url ? (
                                                                                <a href={reservation.diagnostic_invoice.signed_url} target="_blank" rel="noopener noreferrer">
                                                                                    {reservation.diagnostic_invoice.no}
                                                                                </a>
                                                                            ) : (
                                                                                reservation.diagnostic_invoice.no || '-'
                                                                            )}
                                                                            <br />
                                                                            <span>
                                                                                {reservation.diagnostic_invoice.date ? formatDateDMY(reservation.diagnostic_invoice.date) : ''}
                                                                            </span>
                                                                        </div>
                                                                    ) : '-'}
                                                                </td>
                                                            </tr>
                                                            {/* Labour */}
                                                            <tr>
                                                                <td className="center" style={{ width: '40px', paddingLeft: '20px' }}>
                                                                    <Checkbox
                                                                        checked={state.relatedCharges[reservation.id]?.labour || false}
                                                                        disabled={reservation.labour_invoice_id || reservation.labour_net_price === 0}
                                                                        onChange={() => handleRelatedChargeToggle(reservation.id, 'labour')}
                                                                        size='small'
                                                                    />
                                                                </td>
                                                                <td style={{ width: '30%', paddingLeft: '20px' }}>
                                                                    {trans('tables.labourPrice')}
                                                                </td>
                                                                <td style={{ width: '40px' }}>1</td>
                                                                <td style={{ width: '20%' }}>
                                                                    {reservation.labour_net_price_formatted || '0.00'}
                                                                    {state.data?.currency?.name}
                                                                </td>
                                                                <td style={{ width: '20%' }}>
                                                                    {reservation.labour_vat_price_formatted || '0.00'}
                                                                    {state.data?.currency?.name}
                                                                </td>
                                                                <td style={{ width: '20%' }}>
                                                                    {reservation.labour_gross_price_formatted || '0.00'}
                                                                    {state.data?.currency?.name}
                                                                </td>
                                                                <td style={{ width: '10%' }}>
                                                                    {reservation.labour_invoice ? (
                                                                        <div>
                                                                            {reservation.labour_invoice.signed_url ? (
                                                                                <a href={reservation.labour_invoice.signed_url} target="_blank" rel="noopener noreferrer">
                                                                                    {reservation.labour_invoice.no}
                                                                                </a>
                                                                            ) : (
                                                                                reservation.labour_invoice.no || '-'
                                                                            )}
                                                                            <br />
                                                                            <span>
                                                                                {reservation.labour_invoice.date ? formatDateDMY(reservation.labour_invoice.date) : ''}
                                                                            </span>
                                                                        </div>
                                                                    ) : '-'}
                                                                </td>
                                                            </tr>
                                                            {/* Transport */}
                                                            <tr>
                                                                <td className="center" style={{ width: '40px', paddingLeft: '20px' }}>
                                                                    <Checkbox
                                                                        checked={state.relatedCharges[reservation.id]?.transport || false}
                                                                        disabled={reservation.transport_invoice_id || reservation.transport_net_price === 0}
                                                                        onChange={() => handleRelatedChargeToggle(reservation.id, 'transport')}
                                                                        size='small'
                                                                    />
                                                                </td>
                                                                <td style={{ width: '30%', paddingLeft: '20px' }}>
                                                                    {trans('tables.transportPrice')}
                                                                </td>
                                                                <td style={{ width: '40px' }}>1</td>
                                                                <td style={{ width: '20%' }}>
                                                                    {reservation.transport_net_price_formatted || '0.00'}
                                                                    {state.data?.currency?.name}
                                                                </td>
                                                                <td style={{ width: '20%' }}>
                                                                    {reservation.transport_vat_price_formatted || '0.00'}
                                                                    {state.data?.currency?.name}
                                                                </td>
                                                                <td style={{ width: '20%' }}>
                                                                    {reservation.transport_gross_price_formatted || '0.00'}
                                                                    {state.data?.currency?.name}
                                                                </td>
                                                                <td style={{ width: '10%' }}>
                                                                    {reservation.transport_invoice ? (
                                                                        <div>
                                                                            {reservation.transport_invoice.signed_url ? (
                                                                                <a href={reservation.transport_invoice.signed_url} target="_blank" rel="noopener noreferrer">
                                                                                    {reservation.transport_invoice.no}
                                                                                </a>
                                                                            ) : (
                                                                                reservation.transport_invoice.no || '-'
                                                                            )}
                                                                            <br />
                                                                            <span>
                                                                                {reservation.transport_invoice.date ? formatDateDMY(reservation.transport_invoice.date) : ''}
                                                                            </span>
                                                                        </div>
                                                                    ) : '-'}
                                                                </td>
                                                            </tr>
                                                            {/* Parts */}
                                                            <tr>
                                                                <td className="center" style={{ width: '40px', paddingLeft: '20px' }}>
                                                                    <Checkbox
                                                                        checked={state.relatedCharges[reservation.id]?.parts || false}
                                                                        disabled={reservation.parts_invoice_id || reservation.parts_net_price === 0}
                                                                        onChange={() => handleRelatedChargeToggle(reservation.id, 'parts')}
                                                                        size='small'
                                                                    />
                                                                </td>
                                                                <td style={{ width: '30%', paddingLeft: '20px' }}>
                                                                    {trans('tables.partsPrice')}
                                                                </td>
                                                                <td style={{ width: '40px' }}>1</td>
                                                                <td style={{ width: '20%' }}>
                                                                    {reservation.parts_net_price_formatted || '0.00'}
                                                                    {state.data?.currency?.name}
                                                                </td>
                                                                <td style={{ width: '20%' }}>
                                                                    {reservation.parts_vat_price_formatted || '0.00'}
                                                                    {state.data?.currency?.name}
                                                                </td>
                                                                <td style={{ width: '20%' }}>
                                                                    {reservation.parts_gross_price_formatted || '0.00'}
                                                                    {state.data?.currency?.name}
                                                                </td>
                                                                <td style={{ width: '10%' }}>
                                                                    {reservation.parts_invoice ? (
                                                                        <div>
                                                                            {reservation.parts_invoice.signed_url ? (
                                                                                <a href={reservation.parts_invoice.signed_url} target="_blank" rel="noopener noreferrer">
                                                                                    {reservation.parts_invoice.no}
                                                                                </a>
                                                                            ) : (
                                                                                reservation.parts_invoice.no || '-'
                                                                            )}
                                                                            <br />
                                                                            <span>
                                                                                {reservation.parts_invoice.date ? formatDateDMY(reservation.parts_invoice.date) : ''}
                                                                            </span>
                                                                        </div>
                                                                    ) : '-'}
                                                                </td>
                                                            </tr>
                                                        </>
                                                    )}
                                                </React.Fragment>
                                            ))}
                                        </>
                                    )}
                                </tbody>
                            </table>
                        </div>
                    </>
                }

                <div className="footer align-right">
                    {state.loading ?
                        <img src={loader} alt="loading" />
                        :
                        <>
                            <button onClick={handleClose}>
                                {trans('buttons.cancel')}
                            </button>
                            {state.params && (state.params.diagnostic_charge || state.params.labour_charge || state.params.transport_charge || (state.params.parts_charge && state.params.parts_qty))
                                ?
                                <button className="button-primary" type="submit">
                                    {trans('buttons.create')}
                                </button>
                                :
                                ''
                            }
                        </>
                    }
                </div>

            </form>
        </div >
    )
}

export default forwardRef(AddInvoice)